/**
 * ProximaMidnight.js
 * The Proxima Midnight Enemy class
 */

import { Game } from "pixi_core";
import { EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class ProximaMidnight extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probProximasSpear = Game.utils.assertNumber(enemyData.ProbPorixmasSpear, 1);
        const probDefenseStance = Game.utils.assertNumber(enemyData.ProbDefenseStance, 1);
        const probBubblePush = Game.utils.assertNumber(enemyData.ProbBubblePush, 1);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.ePROXIMAS_SPEAR, probProximasSpear);
        this._abilityChoices.addChoice(EnemyAbilities.eDEFENSE_STANCE, probDefenseStance);
        this._abilityChoices.addChoice(EnemyAbilities.eBUBBLE_PUSH, probBubblePush);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.ePROXIMAS_SPEAR:
                Game.fire(GameEvents.eGAME_ABILITY_PROXIMAS_SPEAR, {
                    attackDamage: this._attackDamage,
                    nbHeroes: this._stunNumber,
                    nbTurns: this._stunTurns,
                    startPos: startPos,
                    callback: this._onAbilityCompleted.bind(this)
                });
                break;
            case EnemyAbilities.eDEFENSE_STANCE:
                Game.fire(
                    GameEvents.eGAME_ABILITY_SHIELD_ENEMY,
                    this._shieldNbr,
                    this._shieldDuration,
                    this._shieldPercent,
                    this._onAbilityCompleted.bind(this)
                );
                break;
            case EnemyAbilities.eBUBBLE_PUSH:
                Game.fire(GameEvents.eGAME_ABILITY_ADD_RANDOM_LINE, this._nbAddedLines, startPos, this._onAbilityCompleted.bind(this));
                break;
            default:
                console.error("[ProximaMidnight._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
